/*
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-11 12:16:44
 * @LastEditTime: 2020-09-21 18:16:12
 * @Description: File description
 */
// 老带新V3.2活动规则
export default {
  title: '活动规则',
  content: [
    {
      title: '1. 如何参与【邀请有礼】活动？',
      content: [
        '活动页面点击分享按钮或生成个人海报并分享给好友，好友通过点击链接或者扫描个人海报二维码，在“新同学专属福利”页面<i>注册</i>学而思网校账号，并报名网校同步课，邀请人可获得对应的奖励。'
      ]
    },
    {
      title: '2. 具体可以获得多少奖励？',
      content: [
        '【邀请人奖励】',
        '分享奖励：每位用户从【学而思网校App】-【我的】-【邀请有礼】分享活动至微信群，每次分享可获得100金币，每月最多可获得300金币。',
        '注册奖励：邀请好友注册网校，您和好友都可获得1节精品专题课。您可在活动页面点击兑换，好友可直接在【学而思网校App】-【学习】-【录播课】领取',
        '购课奖励：',
        ' &nbsp; - &nbsp;受邀好友购买<i>单科500元以下</i>的同步课程且未退课，邀请人可获得30元+200元礼品卡+1000金币+1节精品专题课。',
        ' &nbsp; - &nbsp;受邀好友购买单科<i>500元以上（含500元）</i>的同步课程且未退课，邀请人可获得200元现金+200元礼品卡+1000金币+1节专题课兑换卡。',
        ' &nbsp; - &nbsp;礼品卡：是一种现金储值卡，只用于购买学而思网校的课程，不支持购买集团和学而思其他品牌的课程或服务。礼品卡可叠加使用，未消费的余额还保留在礼品卡中。礼品卡使用期限：自领取之日起1年内有效。',
        ' &nbsp; - &nbsp;当邀请多个新好友注册并购课，现金、礼品卡和金币奖励累加，无上限。',
        ' &nbsp; - &nbsp;每名受邀好友最多贡献1次学费，单个好友购买多个课程按1次计算。',
        '举例：',
        '邀请3位好友购买同步课，其中1位受邀好友参与1000元买3科活动，单科实付333元，3科课程按1次计算；2位受邀好友购买了800元的单科课程。',
        '邀请人可获得现金30+200+200=430元，礼品卡200+200+200=600元，金币1000*3=3000，1节精品专题课。',
        '【受邀好友】',
        '好友注册后即可获得2张100元购课优惠券（供购买当季再售同步课程）+1节精品专题课，好友购课后将获得1000金币。'
      ]
    },
    {
      title: '3. 什么情况下奖励会被收回？',
      content: [
        '当受邀好友退课后：①邀请人的200元/30元现金奖励将被收回；②礼品卡全部收回；③邀请人和受邀好友的1000金币奖励全部收回（如已发生金币兑换，将会扣除金币余额直至归零）；④被邀好友的100元购课优惠券不再返还；④精品专题课不会收回。'
      ]
    },
    {
      title: '4. 获得的奖金如何查看和提现？',
      content: [
        '现金奖励：学而思网校App提现方式：点击【我的】--【邀请有礼】--【查看奖励明细】--【提现】',
        '学而思网校公众号提现方式：微信搜索“学而思网校”--关注并进入公众号--【我的网校】',
        '--【邀好友返学费】--根据提示完成提现。'
      ]
    },
    {
      title: '5. 礼品卡怎么用? ',
      content: [
        '学而思网校App 8.10版本。10月10日之后更新下载后，【我的】-【礼品卡】-【邀请有礼礼品卡】。礼品卡不能提现，只能在购物车结算时选择使用，可叠加使用，未消费的余额会继续保留在礼品卡中。'
      ]
    },
    {
      title: '6. 为什么我有现金学费但是不能提现？',
      content: [
        '累计获得的学费中，可提现金额为您在学而思网校已消费金额的总和（不包含未结课的课程），不可提现金额，仍会保留在您的账号中。当您继续消费后，可提现金额可增加。',
        '提现请关注“学而思网校”微信公众号，点击“邀好友返学费”，按照提示绑定个人信息。学而思网校不会泄露您的个人隐私信息，请您放心填写。'
      ]
    },
    {
      title: '特殊问题解释',
      content: [
        '本活动所有数据以学而思网校系统数据统计为准，如有发现违规行为（恶意刷单获得奖金等），学而思网校有权取消该用户活动资格以及奖励资格，并追究相关责任。',
        '若您对活动规则有疑问，或参与活动时遇到问题，可拨打学而思网校客服电话：400-800-2211咨询。'
      ]
    }
  ]
}
